import Question from './FAQuestions';

const faqs = [
	{
		id: 1,
		question: "How does the Advent Calendar Marketing Campaign work?",
		answer:
			"The Advent Calendar Marketing Campaign is an interactive promotion where participants can open an \"advent calendar gift box\" each day leading up to a specified end date. By completing specified activities, such as watching videos or answering questions, participants can open the gift boxes, each of which represents a charitable contribution made by Buddy on their behalf.",
	},
	{
		id: 2,
		question: "What is the purpose of this campaign?",
		answer:
			"The purpose of this campaign is to spread joy during the holiday season while making a positive impact on a charitable cause. Buddy will make charitable donations to a designated food bank at the end of the campaign, and participants' engagement helps maximize these donations.\n" +
			"Is there a cost to participate in the campaign?\n" +
			"\n" +
			"No, participation in the Advent Calendar Marketing Campaign is entirely free.",
	},
	{
		id: 3,
		question: "How do I participate in the campaign?",
		answer:
			"To participate, visit our website and follow the instructions to open each day's advent calendar gift box. Engage in the specified activities to unlock the boxes.",
	},
	{
		id: 4,
		question: "What do I need to do to open a gift box each day?",
		answer:
			"To open a gift box, you may need to complete various activities, such as watching a video, answering questions, or other interactive tasks as specified for each box.",
	},
	{
		id: 5,
		question: "How often can I open gift boxes?",
		answer:
			"Participants can open one gift box per day during the campaign period.",
	},
	{
		id: 6,
		question: "What happens when I open a gift box?",
		answer:
			"Each gift box contains an item or symbol representing a charitable contribution. Buddy or one of our partners will make a donation to the food bank based on your participation and the gifts you reveal.\n" +
			"\n" +
			"To qualify for opening the gift box, you may need to watch some educational videos and answer some quick surveys.",
	},
	{
		id: 7,
		question: "Can I donate directly to the charitable cause without participating in the campaign?",
		answer:
			"Yes, if you wish to make a direct donation to support the cause without participating in the campaign, please visit our website for donation options.",
	},
	{
		id: 8,
		question: "Are my personal details and data safe when participating in the campaign?",
		answer:
			"We take data protection seriously. Your personal information will be handled in compliance with applicable data protection laws and our Privacy Policy, ensuring the security and confidentiality of your data.",
	},
	{
		id: 9,
		question: "Can I unsubscribe from marketing emails at any time?",
		answer:
			"Yes, you can unsubscribe from marketing emails at any time by following the instructions provided in the emails or by adjusting your email preferences in your account settings. You can do so by going into your account profile.",
	},
	{
		id: 10,
		question: "What is GDPR, and how does it relate to the campaign?",
		answer:
			"GDPR (General Data Protection Regulation) is a European Union data protection regulation that governs the processing of personal data. We ensure that our data handling practices comply with GDPR, and we obtain consent from participants as required.",
	},
	{
		id: 11,
		question: "Who are the sponsors and advertisers involved in the campaign?",
		answer:
			"We collaborate with various sponsors and advertisers who support our campaign. A list of these entities and their involvement can be found inside our sponsors and partners section on this page.",
	},
	{
		id: 12,
		question: "How will the charitable donations be distributed, and to which food bank or charitable organization?",
		answer:
			"Charitable donations will be distributed to a designated food bank as specified in the campaign. We will provide regular updates on the distribution of funds and the impact on our website.",
	},
	{
		id: 13,
		question: "What happens if the budget limit is reached before the campaign ends?",
		answer:
			"If the budget limit is reached before the campaign's end date, we may explore opportunities to accept additional contributions from sponsors or participants to continue supporting the charitable cause.\n" +
			"\n" +
			"The game will continue playing as normal and you can still continue raising awareness. If you continue to play it will help us to attract other companies who will join us for this great cause.",
	},
	{
		id: 14,
		question: "How can I contact the campaign organizers for further questions or assistance?",
		answer:
			"For any further questions or assistance, please contact our support team at adventcalendar@buddy.hr, and we will be happy to assist you.",
	},
	{
		id: 15,
		question: "Who is Buddy?",
		answer:
			"Buddy is an HR and payroll solution that helps employers pay their employees correctly. Serving customers across Malta and the United Kingdom Buddy has been a key payroll compliance driver, heavily leveraging technology and automation.\n" +
			"\n" +
			"Our mission is to bring people closer together by ensuring that Employees, Employers and the Payrollers. This ensures that everyone understands what needs to be done to ensure everyone is paid correctly and on time. Your input is critical to getting paid on time.",
	},
	{
		id: 16,
		question: "I represent a business how can I help?",
		answer:
			"We are looking for brands to help donate items to the food bank. What we are doing differently is that we are having people actually view the items that are being donated and feel part of the journey. Instead of spending ridiculous amounts on social media for advertising, we hope to divert the funds to people in need.",
	},
	{
		id: 17,
		question: "I want to learn more about Buddy, what should I do?",
		answer:
			"For employees, we highly recommend that you follow us on TikTok, that is the primary channel we use to provide valuable information for employees.\n" +
			"\n" +
			"For employers, HR manager or a Payroller (anyone who does payroll really), we highly suggest that you follow our LinkedIn and Podcast. These are always full of useful insights for employers.",
	},
	// More questions...
]

export default function Faq() {
	return (
		<div className="px-10">
			<div className="mx-auto max-w-7xl py-16 px-4 sm:py-24 sm:px-6">
				<div className="lg:mx-auto lg:max-w-2xl lg:text-center">
					<h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">Frequently asked questions</h2>
					<p className="mt-4 text-gray-800">
						Got questions around our pricing? We've got you covered.
					</p>
				</div>
				<div className="mt-20">
					<dl className="space-y-10 lg:grid lg:grid-cols-2 lg:gap-x-8 lg:gap-y-10 lg:space-y-0">
						{faqs.map((faq,index) => (
							<Question faq={faq} key={index}/>
						))}
					</dl>
				</div>
			</div>
		</div>
	)
}